import type { Client } from '../types'

const LEGAL_FORM_PREFIX = new RegExp(
  '^\\s*(?:' + [
    'общество\\s+с\\s+ограниченной\\s+ответственностью',
    'публичное\\s+акционерное\\s+общество',
    'непубличное\\s+акционерное\\s+общество',
    'открытое\\s+акционерное\\s+общество',
    'закрытое\\s+акционерное\\s+общество',
    'акционерное\\s+общество',
    'индивидуальный\\s+предприниматель',
    'федеральное\\s+государственное\\s+унитарное\\s+предприятие',
    'государственное\\s+унитарное\\s+предприятие',
    'муниципальное\\s+унитарное\\s+предприятие',
    'автономная\\s+некоммерческая\\s+организация',
    'производственный\\s+кооператив',
    'потребительский\\s+кооператив',
    'ооо', 'пао', 'нао', 'оао', 'зао', 'ао', 'ип', 'фгуп', 'гуп', 'муп', 'ано', 'нко',
  ].join('|') + ')(?:\\s+|[.,:;—-]+\\s*)',
  'iu',
)

const EDGE_QUOTES = /^[\s«»„“”"'`]+|[\s«»„“”"'`]+$/gu

export function displayCompanyName(company: string): string {
  let result = company.trim()
  for (let index = 0; index < 2; index += 1) {
    const stripped = result.replace(LEGAL_FORM_PREFIX, '').trim()
    if (stripped === result) break
    result = stripped
  }
  result = result.replace(EDGE_QUOTES, '').trim()
  return result || company.trim()
}

export function companySortKey(company: string): string {
  return displayCompanyName(company)
    .toLocaleLowerCase('ru-RU')
    .replace(/ё/g, 'е')
    .replace(/[^а-яa-z0-9]+/giu, ' ')
    .trim()
}

export function sortClientsByDisplayName(clients: Client[]): Client[] {
  return [...clients].sort((left, right) =>
    companySortKey(left.company).localeCompare(companySortKey(right.company), 'ru-RU', {
      numeric: true,
      sensitivity: 'base',
    }),
  )
}

export function clientMatchesCompanyQuery(client: Client, query: string): boolean {
  const normalized = companySortKey(query)
  if (!normalized) return true
  const haystack = companySortKey(`${displayCompanyName(client.company)} ${client.company} ${client.taxId ?? ''}`)
  return haystack.includes(normalized)
}
